import { Product } from "@deliverr/commons-clients";
import { InboundPackageSummary, ShippingPlanItemLotExpirationRaw } from "@deliverr/inbound-client";
import { CasePackDefaultData } from "common/clients/inbound/bulkUpload/CasePackDefaultData";
import { useCallback } from "react";
import { useIntlDtcSingleSkuBulkUploadHandler } from "./hooks/useIntlDtcSingleSkuBulkUploadHandler";

export const useHandleIntlDtcSingleSkuBulkUploadSuccess = () => {
  const { handleIntlDtcSingleSkuBulkUploadSuccess: handleBulkUpload } = useIntlDtcSingleSkuBulkUploadHandler();

  const handleIntlDtcSingleSkuBulkUploadSuccess = useCallback(
    async (
      products: (Product & { qty: number })[],
      caseDimensions?: CasePackDefaultData[],
      lotTracking?: { [dsku: string]: ShippingPlanItemLotExpirationRaw },
      packages?: InboundPackageSummary[]
    ) => {
      await handleBulkUpload({
        products,
        caseDimensions,
        lotTracking,
        packages,
      });
    },
    [handleBulkUpload]
  );

  return { handleIntlDtcSingleSkuBulkUploadSuccess };
};
